import { CalendarClock } from "lucide-react";

// Why an available Rider gets no work: dispatch only commits work inside the
// Rider's scheduled shift (HR > Shifts). Without this the home screen said
// "Available for deliveries" while every parcel was being refused, and the
// Rider had no way to know. Shown only while the Rider is available and not on
// a shift; nothing here is an action a Rider can take themselves.
const time = (value, timezone) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "at a time your store needs to confirm";
  return new Intl.DateTimeFormat("en-PH", {
    ...(timezone ? { timeZone: timezone } : {}),
    weekday: "short", month: "short", day: "numeric", year: "numeric",
    hour: "numeric", minute: "2-digit",
  }).format(date);
};

export default function RiderShiftNotice({ duty, className = "" }) {
  const shift = duty?.shift;
  if (duty?.dutyState !== "ON_DUTY" || !shift || !["NO_SHIFT", "BETWEEN_SHIFTS"].includes(shift.status)) return null;

  return (
    <div
      role="status"
      data-testid="rider-shift-notice"
      className={`rounded-xl border border-amber-300 bg-amber-50 p-3 dark:border-amber-500/40 dark:bg-amber-500/10 ${className}`}
    >
      <p className="flex items-center gap-2 text-sm font-semibold text-amber-900 dark:text-amber-200">
        <CalendarClock className="h-4 w-4 shrink-0" aria-hidden="true" />
        {shift.status === "NO_SHIFT" ? "You have no shift scheduled" : "You are not on shift right now"}
      </p>
      <p className="mt-1 max-w-prose text-sm text-amber-900/90 dark:text-amber-200/90">
        {shift.status === "NO_SHIFT"
          ? "New parcels are only given to riders during their shift. Ask your store to schedule one for you."
          : `New parcels are only given to riders during their shift. Your next shift starts ${time(shift.nextStartsAt, shift.timezone)}${shift.timezone ? ` (${shift.timezone})` : ""}.`}
      </p>
    </div>
  );
}
